import React, { useState, useEffect } from 'react';
import styles from '../../css/studyIndexCSS.less';
import {
  ContentTypes,
  ExercisesType,
  ExercisesItemType,
  ExercisesConfigType,
} from '@/types/camp/study/contentTypes';
import { QuestionType } from '@/types/camp/study/index';
import { Form, Input } from 'antd';
import Editor from '@digit-fe/digit-editor-new';
import { editParseJson } from '@/utils/index';
import { CheckCircleFilled, CloseCircleFilled, HourglassOutlined } from '@ant-design/icons';
import { ReactComponent as RewardSvg } from '@/static/images/reward_f.svg';
import { isUndefined } from 'lodash';

interface Props {
  item: ContentTypes;
}
const QuestionPreview: React.FC<Props> = ({ item }) => {
  const info = item.info as ExercisesType;
  const [questions, setQuestions] = useState<ExercisesItemType[]>(info.question);
  const [exercises, setExercises] = useState<ExercisesConfigType[]>(info.exercises || []);
  const radioIsRight = (item: ExercisesItemType) => {
    return item.info?.options?.some(
      (option) => option.description === item.studentAnswer && option.answer === true,
    );
  };
  const radioRight = (item: ExercisesItemType) => {
    let correctOption = item.info?.options?.find(
      (option) => item.studentAnswer && option.answer === true,
    );
    if (correctOption) {
      return String.fromCharCode(65 + correctOption.index);
    }
  };

  const radioMyRight = (item: ExercisesItemType) => {
    let correctOption = item.info?.options?.find(
      (option) => option.description === item.studentAnswer,
    );
    if (correctOption) {
      return String.fromCharCode(65 + correctOption.index);
    }
  };

  const isCheckboxRight = (item: ExercisesItemType) => {
    const studentAnswer = editParseJson(item.studentAnswer);
    // console.log('studentAnswer', studentAnswer);
    // console.log('studentAnswer - item.info?.options', item.info?.options);
    if (studentAnswer.length > 0 && item.info?.options) {
      // 存储所有正确选项的描述
      const correctDescriptions = item.info?.options
        .filter((item) => item.answer)
        .map((item) => item.description);
      // 判断传入的答案数组与正确选项的描述数组是否完全一致
      return JSON.stringify(correctDescriptions.sort()) === JSON.stringify(studentAnswer.sort());
    }
  };

  const checkboxRight = (item: ExercisesItemType, user: boolean = false) => {
    let correctLetters: any = [];
    const studentAnswer = editParseJson(item.studentAnswer);
    if (studentAnswer.length > 0 && user) {
      studentAnswer.forEach((answer: any) => {
        let correctOption;
        correctOption = item.info?.options?.find((option) => option.description === answer);

        if (correctOption) {
          const letter = String.fromCharCode(65 + correctOption.index);
          correctLetters.push(letter);
        }
      });
      correctLetters.sort();
      return correctLetters.join('、');
    } else {
      let letters: any = [];
      letters = item.info?.options
        ?.filter((option) => option.answer === true)
        .map((option) => String.fromCharCode(65 + option.index))
        .sort();
      if (letters.length === 0) {
        return '';
      }
      return letters.join('、');
    }
  };

  const successText = (
    <div className="flex_1 col52c" style={{ gap: 4 }}>
      <CheckCircleFilled />
      <span>正确</span>
    </div>
  );
  const failText = (
    <div className="flex_1 colff3" style={{ gap: 4 }}>
      <CloseCircleFilled />
      <span>错误</span>
    </div>
  );

  const radioShowItem = (item: any) => {
    if (item.info.answer === true && item.studentAnswer === String(item.info.answer)) {
      return (
        <>
          <div className="ant-radio-wrapper ant-radio-wrapper-in-form-item ant-radio-wrapper-checked">
            <span>A. 正确</span>
          </div>

          <div className="ant-radio-wrapper ant-radio-wrapper-in-form-item">
            <span>B. 错误</span>
          </div>
        </>
      );
    } else if (item.info.answer === false && item.studentAnswer === String(item.info.answer)) {
      return (
        <>
          <div className="ant-radio-wrapper ant-radio-wrapper-in-form-item ">
            <span>A. 正确</span>
          </div>

          <div className="ant-radio-wrapper ant-radio-wrapper-in-form-item ant-radio-wrapper-checked">
            <span>B. 错误</span>
          </div>
        </>
      );
    } else if (item.info.answer === true) {
      return (
        <>
          <div className="ant-radio-wrapper ant-radio-wrapper-in-form-item ant-radio-wrapper-checked">
            <span>A. 正确</span>
          </div>

          <div className="ant-radio-wrapper ant-radio-wrapper-in-form-item ant-radio-wrapper-err">
            <span>B. 错误</span>
          </div>
        </>
      );
    } else {
      return (
        <>
          <div className="ant-radio-wrapper ant-radio-wrapper-in-form-item ant-radio-wrapper-err">
            <span>A. 正确</span>
          </div>

          <div className="ant-radio-wrapper ant-radio-wrapper-in-form-item ant-radio-wrapper-checked">
            <span>B. 错误</span>
          </div>
        </>
      );
    }
  };

  // 处理显示对应表单类型
  const handleFormItem = (item: ExercisesItemType, index: number) => {
    switch (item.type) {
      // 单选题
      case QuestionType.SINGLE_CHOICE:
        if (item.info && typeof item.info === 'object') {
          return (
            <div
              className={`my_ant_form_item ${
                radioIsRight(item) ? 'form_item_right' : 'form_item_err'
              } `}
              id={`${item.id}_title`}
            >
              <div className="form_tag">单选题</div>

              <Form.Item key={item.id} name={item.id} label={item.title}>
                <div className="answer_box">
                  <span className="col808">正确答案：</span>
                  <span className="fw600">{radioRight(item)}</span>
                  <span className="col808" style={{ marginLeft: 22 }}>
                    学员答案：
                  </span>
                  <span className="fw600">{radioMyRight(item)}</span>
                  <span style={{ marginLeft: 22 }}>
                    {radioIsRight(item) ? successText : failText}
                  </span>
                  {radioIsRight(item) && (
                    <div className="user_score_box flex_1">
                      <RewardSvg style={{ width: 18, marginRight: 4 }} />
                      <span>奖励 {item.score} 学分</span>
                    </div>
                  )}
                </div>

                {item.description && Object.keys(item.description).length !== 0 && (
                  <div style={{ marginBottom: 16 }}>
                    <Editor
                      content={item.description && editParseJson(item.description)}
                      editable={false}
                      titleProps={{ showTitle: false }}
                      catalogProps={{ showCatalog: false }}
                    />
                  </div>
                )}

                <div className="ant-radio-group ant-radio-group-outline">
                  {item.info?.options?.map((o, index) => (
                    <div
                      className={`ant-radio-wrapper ant-radio-wrapper-in-form-item ${
                        o.answer === false && !radioIsRight(item)
                          ? ' ant-radio-wrapper-err'
                          : o.answer === true
                          ? 'ant-radio-wrapper-checked'
                          : ''
                      }`}
                    >
                      <span>{`${String.fromCharCode(65 + index)}. ${o.description}`}</span>
                    </div>
                  ))}
                </div>
                {item.analysis && (
                  <>
                    <div style={{ marginTop: 24 }}>
                      <span className="f16 fw600">题目解析：</span>
                    </div>
                    <Editor
                      key={`edit_${item.id}`}
                      content={JSON.parse(item.analysis)}
                      editable={false}
                      titleProps={{ showTitle: false }}
                      catalogProps={{ showCatalog: false }}
                    />
                  </>
                )}
              </Form.Item>
            </div>
          );
        }
        break;
      // 判断题
      case QuestionType.TURE_OR_FALSE:
        if (item.info && typeof item.info === 'object') {
          return (
            <div
              className={`my_ant_form_item ${
                item.studentAnswer === String(item.info.answer)
                  ? 'form_item_right'
                  : 'form_item_err'
              } `}
              id={`${item.id}_title`}
            >
              <div className="form_tag">判断题</div>
              <Form.Item key={item.id} name={item.id} label={item.title}>
                <div className="answer_box">
                  <span className="col808">正确答案：</span>
                  <span className="fw600">{item.info.answer === true ? 'A' : 'B'}</span>
                  <span className="col808" style={{ marginLeft: 22 }}>
                    学员答案：
                  </span>
                  <span className="fw600"> {item.studentAnswer === 'true' ? 'A' : 'B'}</span>
                  <span style={{ marginLeft: 22 }}>
                    {item.studentAnswer === String(item.info.answer) ? successText : failText}
                  </span>
                  {item.studentAnswer === String(item.info.answer) && (
                    <div className="user_score_box flex_1">
                      <RewardSvg style={{ width: 18, marginRight: 4 }} />
                      <span>奖励 {item.score} 学分</span>
                    </div>
                  )}
                </div>

                {item.description && Object.keys(item.description).length !== 0 && (
                  <div style={{ marginBottom: 16 }}>
                    <Editor
                      content={item.description && editParseJson(item.description)}
                      editable={false}
                      titleProps={{ showTitle: false }}
                      catalogProps={{ showCatalog: false }}
                    />
                  </div>
                )}

                <div className="ant-radio-group ant-radio-group-outline">{radioShowItem(item)}</div>
                {item.analysis && (
                  <>
                    <div style={{ marginTop: 24 }}>
                      <span className="f16 fw600">题目解析：</span>
                    </div>
                    <Editor
                      key={`edit_${item.id}`}
                      content={JSON.parse(item.analysis)}
                      editable={false}
                      titleProps={{ showTitle: false }}
                      catalogProps={{ showCatalog: false }}
                    />
                  </>
                )}
              </Form.Item>
            </div>
          );
        }
        break;
      // 主观题
      case QuestionType.SUBJECTIVE:
        return (
          <div className="my_ant_form_item" id={`${item.id}_title`}>
            <div className="form_tag">主观题</div>
            <Form.Item key={item.id} label={item.title} name={item.id}>
              {item.description && (
                <Editor
                  style={{ backgroundColor: '#F7FAFD' }}
                  content={item.description && JSON.parse(item.description)}
                  editable={false}
                  titleProps={{ showTitle: false }}
                  catalogProps={{ showCatalog: false }}
                />
              )}

              <div className={styles.answering_area}>
                <span className="f16 fw600">学员答案</span>
                {!isUndefined(item.score) ? (
                  <div className="user_score_box flex_1" style={{ marginLeft: 6 }}>
                    <RewardSvg style={{ width: 18, marginRight: 4 }} />
                    <span>奖励 {item.score} 学分</span>
                  </div>
                ) : (
                  <div className="user_score_box flex_1" style={{ marginLeft: 6 }}>
                    <HourglassOutlined style={{ width: 18, marginTop: 1 }} />
                    <span>助教批阅中</span>
                  </div>
                )}
              </div>

              <Editor
                key={`edit_${item.id}`}
                content={item.studentAnswer && JSON.parse(item.studentAnswer)}
                editable={false}
                style={{ backgroundColor: '#F7FAFD' }}
                titleProps={{ showTitle: false }}
                catalogProps={{ showCatalog: false }}
              />

              {item.analysis && (
                <>
                  <div style={{ marginTop: 24 }}>
                    <span className="f16 fw600">题目解析：</span>
                  </div>
                  <Editor
                    key={`edit_${item.id}`}
                    style={{ backgroundColor: '#F7FAFD' }}
                    content={JSON.parse(item.analysis)}
                    editable={false}
                    titleProps={{ showTitle: false }}
                    catalogProps={{ showCatalog: false }}
                  />
                </>
              )}
              {item.comment && (
                <>
                  <div className={styles.answering_area}>
                    <span className="f16 fw600">评语：</span>
                  </div>
                  <Editor
                    key={`edit_${item.id}`}
                    content={item.comment && JSON.parse(item.comment)}
                    editable={false}
                    style={{ backgroundColor: '#F7FAFD' }}
                    titleProps={{ showTitle: false }}
                    catalogProps={{ showCatalog: false }}
                  />
                </>
              )}
            </Form.Item>
          </div>
        );

        break;

      // 多选题
      case QuestionType.MULTIPLE_CHOICE:
        if (item.info && typeof item.info === 'object') {
          return (
            <div
              className={`my_ant_form_item ${
                isCheckboxRight(item) ? 'form_item_right' : 'form_item_err'
              } `}
              id={`${item.id}_title`}
            >
              <div className="form_tag">多选题</div>
              <Form.Item key={item.id} name={item.id} label={item.title}>
                <div className="answer_box">
                  <span className="col808">正确答案：</span>
                  <span className="fw600">{checkboxRight(item)}</span>
                  <span className="col808" style={{ marginLeft: 22 }}>
                    学员答案：
                  </span>
                  <span className="fw600">{checkboxRight(item, true)}</span>
                  <span style={{ marginLeft: 22 }}>
                    {isCheckboxRight(item) ? successText : failText}
                  </span>
                  {isCheckboxRight(item) && (
                    <div className="user_score_box flex_1">
                      <RewardSvg style={{ width: 18, marginRight: 4 }} />
                      <span>奖励 {item.score} 学分</span>
                    </div>
                  )}
                </div>

                {item.description && Object.keys(item.description).length !== 0 && (
                  <div style={{ marginBottom: 16 }}>
                    <Editor
                      content={item.description && editParseJson(item.description)}
                      editable={false}
                      titleProps={{ showTitle: false }}
                      catalogProps={{ showCatalog: false }}
                    />
                  </div>
                )}

                <div className="ant-radio-group ant-radio-group-outline">
                  {item.info?.options?.map((o, index) => (
                    <div
                      className={`ant-radio-wrapper ant-radio-wrapper-in-form-item ${
                        o.answer === false && !isCheckboxRight(item)
                          ? ' ant-radio-wrapper-err'
                          : o.answer === true
                          ? 'ant-radio-wrapper-checked'
                          : ''
                      }`}
                    >
                      <span>{`${String.fromCharCode(65 + index)}. ${o.description}`}</span>
                    </div>
                  ))}
                </div>
                {item.analysis && (
                  <>
                    <div style={{ marginTop: 24 }}>
                      <span className="f16 fw600">题目解析：</span>
                    </div>
                    <Editor
                      key={`edit_${item.id}`}
                      content={JSON.parse(item.analysis)}
                      editable={false}
                      titleProps={{ showTitle: false }}
                      catalogProps={{ showCatalog: false }}
                    />
                  </>
                )}
              </Form.Item>
            </div>
          );
        }
        break;
      default:
        return <Input hidden />;
    }
  };

  return (
    <div className={styles.questions_main}>
      <div className={styles.new_form_item_preview}>
        {/* 习题只有一个分组 */}
        {exercises.length < 2 && (
          <div className="f20" style={{ marginBottom: 16 }}>
            <div>
              {exercises[0].title}（每题{exercises[0].rewardPer}分）
            </div>
          </div>
        )}
        {questions.map((item, index) => (
          <div>
            {item.categoryName && exercises.length >= 2 && (
              <div className="f20" style={{ padding: '16px 0 16px' }}>
                {item.categoryName}（每题{item.rewardScore}分）
              </div>
            )}
            <div>{handleFormItem(item, index)}</div>
          </div>
        ))}
      </div>
    </div>
  );
};
export default QuestionPreview;
